import { Tooltip } from "@mui/material";
import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

type Props = {
  handleOnProductClick: (product: any, stock: any) => void;
  product: any;
  stock: any;
};

function ProductReference({ handleOnProductClick, product, stock }: Props) {
  const classes = useStyles({
    receptionReferenceId: product.receptionReferenceId,
    isReferenced: product.relatedProduct?.isReferenced,
  });
  return (
    <Tooltip
      title={product.relatedProduct?.designation}
      onClick={() => handleOnProductClick(product, stock)}
    >
      <span>
        <span className={classes.typeCircle} />
        &nbsp;
        {product.relatedProduct?.isReferenced === false
          ? "Non référencé"
          : product.relatedProduct?.reference}
      </span>
    </Tooltip>
  );
}

export default ProductReference;

const useStyles = createUseStyles(() => ({
  typeCircle: {
    background: (props: {
      receptionReferenceId: number;
      isReferenced: boolean;
    }) =>
      props.receptionReferenceId
        ? theme.color.blueLight
        : !props.isReferenced
        ? theme.color.black
        : "",
    borderRadius: "50%",
    display: "inline-block",
    height: 10,
    width: 10,
  },
}));
